export default "__VITE_ASSET__GlOZEhUx__"